export class UsuarioParameter {
	public codCliente: string = '';
	public docEmpresa: string = '';
	public docUsuario: string = '';
	public codTpoPortal: string = '';
}
